import { inject, signal } from '@angular/core';
import { HttpErrorService, StationsService } from '../../../services';
import { PublicRoutes } from '../../../enums';
import { PrimeNgDate, Station } from '../../../models';
import { Router } from '@angular/router';

/** when extending this class be sure to implement ngOnInit */
export class NgxAimStationSelectDay {
  // ngOnInit() {
  //   this.init();
  // }

  stationsService = inject(StationsService);
  httpErrorService = inject(HttpErrorService);
  router = inject(Router);

  routes = PublicRoutes;
  selectedGroup = this.stationsService.getSelectedGroup();
  selectedDate = this.stationsService.getSelectedDate();
  selectedStation = this.stationsService.getSelectedStation();
  minDate = new Date();
  maxDate = new Date();
  disabledDates: Date[] = [];
  isLoading = signal(true);

  init() {
    if (this.selectedGroup && this.selectedStation) {
      this.findOneStation();
    }
  }

  findOneStation() {
    this.stationsService.findOneStation(this.selectedGroup!.Id, this.selectedStation!.Id, true).subscribe({
      next: (station) => this.onStationSuccess(station),
      error: (err) => this.onStationsError(err),
    });
  }

  onStationSuccess(station: Station) {
    this.isLoading.set(false);
    this.stationsService.setSelectedStation(station);
    this.selectedStation = this.stationsService.getSelectedStation();
    this.setDisabledDates();
  }

  onStationsError(err: any) {
    this.isLoading.set(false);
    this.httpErrorService.onHttpError(err, 'Could not load stations');
  }

  setDisabledDates() {
    this.disabledDates = [...this.selectedGroup!.disabledDates, ...this.selectedStation!.disabledDates];
    this.minDate = this.selectedGroup!.minDate;
    this.maxDate = this.selectedGroup!.maxDate;
  }

  onSelect(date: Date) {
    this.stationsService.setSelectedDate(date);
  }

  isDateDisabled(primeNgDate: PrimeNgDate) {
    return !primeNgDate.selectable;
  }

  onNextClick() {
    if (this.stationsService.skipDurationSelect) {
      this.router.navigate([this.routes.STATIONS, this.routes.GROUPS, this.selectedGroup?.Id, this.routes.SELECT_TIME]);
    } else {
      this.router.navigate([this.routes.STATIONS, this.routes.GROUPS, this.selectedGroup?.Id, this.routes.SELECT_DURATION]);
    }
  }

  onBackClick() {
    if (this.stationsService.amountOfStationsInGroup === 1) {
      this.router.navigate(['/', this.routes.STATIONS, this.routes.GROUPS]);
    } else {
      this.router.navigate(['/', this.routes.STATIONS, this.routes.GROUPS, this.selectedGroup?.Id, this.routes.SELECT_STATION]);
    }
  }
}